"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionDescriptions = exports.getOptionNames = exports.getOptionByDescription = exports.getOptionByName = exports.getOptionByAlias = exports.getBitRange = exports.getBitLabel = void 0;
var Arrays_1 = require("./util/Arrays");
/**
 * Converts a hexadecimal string to binary.
 * Any leading zeros are removed from the returned string.
 */
var hexToBinary = function (hex) {
    return parseInt(hex, 16).toString(2);
};
/**
 * Returns a string of the corresponding bit position(s).
 */
var getBitLabel = function (setting) {
    if (setting.mask === undefined) {
        return undefined;
    }
    var bitRange = (0, exports.getBitRange)(setting);
    if (!bitRange)
        return undefined;
    if (bitRange.high === bitRange.low) {
        return "bit ".concat(bitRange.high);
    }
    return "bit ".concat(bitRange.high, "-").concat(bitRange.low);
};
exports.getBitLabel = getBitLabel;
/**
 * Converts the hexadecimal mask provided within the register setting
 *   and returns an interface containing the corresponding low and high bit positions.
 */
var getBitRange = function (setting) {
    if (!setting.mask)
        return undefined;
    var processedHex = hexToBinary(setting.mask);
    return {
        high: processedHex.length - 1,
        low: getBitRangeLow(processedHex),
    };
};
exports.getBitRange = getBitRange;
var getOptionByAlias = function (alias, setting) {
    var _a;
    return (0, Arrays_1.find)((_a = setting === null || setting === void 0 ? void 0 : setting.options) !== null && _a !== void 0 ? _a : [], function (option) { return option.alias == alias; });
};
exports.getOptionByAlias = getOptionByAlias;
var getOptionByName = function (name, setting) {
    var _a;
    return (0, Arrays_1.find)((_a = setting === null || setting === void 0 ? void 0 : setting.options) !== null && _a !== void 0 ? _a : [], function (option) { return option.name == name; });
};
exports.getOptionByName = getOptionByName;
var getOptionByDescription = function (description, setting) {
    var _a;
    return (0, Arrays_1.find)((_a = setting.options) !== null && _a !== void 0 ? _a : [], function (option) { return option.description == description; });
};
exports.getOptionByDescription = getOptionByDescription;
var getOptionNames = function (setting) {
    var _a;
    return (0, Arrays_1.map)((_a = setting.options) !== null && _a !== void 0 ? _a : [], function (option) { return option.name; });
};
exports.getOptionNames = getOptionNames;
var getOptionDescriptions = function (setting) {
    var _a;
    return (0, Arrays_1.map)((_a = setting.options) !== null && _a !== void 0 ? _a : [], function (option) { return option.description; });
};
exports.getOptionDescriptions = getOptionDescriptions;
function getBitRangeLow(processedHex) {
    if (processedHex.charAt(1) === "1") {
        var index = 1;
        while (processedHex.charAt(index) === "1") {
            index++;
        }
        return processedHex.length - index;
    }
    else {
        return processedHex.length - 1;
    }
}
//# sourceMappingURL=Setting.js.map